class ArticleContent extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', this.updateContent.bind(this));
  }

  updateContent() {
    this.iframeAspectRatio();
    this.classList.remove('loading');
  }

  iframeAspectRatio() {
    const iframes = this.querySelectorAll('iframe');
    if (!iframes) return;

    iframes.forEach(iframe => {
      const iframeContainer =  document.createElement('div');
      iframeContainer.classList.add('iframe-container');
      iframe.insertAdjacentElement('beforebegin', iframeContainer);
      iframeContainer.insertAdjacentElement('afterbegin', iframe);
    })
  }
}

customElements.define('article-content', ArticleContent);

class ArticleSidebar extends HTMLElement {
  constructor() {
    super();
    this.stickyHeader = document.querySelector('.sticky-header');
    this.announcementBarCloseBtn = document.querySelector('.announcement-bar__close');

    window.addEventListener('scroll', this.stickySidebar.bind(this));
    window.addEventListener('resize', this.stickySidebar.bind(this));
    document.addEventListener('DOMContentLoaded', this.stickySidebar.bind(this));
    if (this.announcementBarCloseBtn) {
      this.announcementBarCloseBtn.addEventListener('click', this.stickySidebar.bind(this));
    }
  }

  stickySidebar() {
    if (window.innerWidth >= 990) {
      // Adjust top position
      this.style.top = `calc(${getComputedStyle(this.stickyHeader).height} + 24px)`;
      for (let i = 1; i <= 300; i++) {
        setTimeout(() => {
          this.style.top = `calc(${getComputedStyle(this.stickyHeader).height} + 24px)`;
        }, i);
      }
    }
  }
}

customElements.define('article-sidebar', ArticleSidebar);

class ArticleShare extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onShareClick.bind(this));
  }

  onShareClick() {
    this.copyToClipboard('copyInput', 'copiedTextAlert');
  }

  copyToClipboard(inputId, alertId) {
    const copyText = this.querySelector(`#${inputId}`);
    const copyTextAlert = this.querySelector(`#${alertId}`);

    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);

    copyTextAlert.classList.remove('activated');
    setTimeout(() => {
      copyTextAlert.classList.add('activated');
    }, 20)
  }
}

customElements.define('article-share', ArticleShare);